export default __webpack_public_path__ + "static/media/logo.ad002ef0.svg";